<script setup>
// For pages without the customer area footer (e.g. landing pages with hidden navigation).
import { COOKIE_SETTINGS_HASH, cookieBannerMounted } from '../../helpers/cookieSettings';
import IconCookie from '../icons/iconCookie.vue';
import IconSettings from '../icons/iconSettings.vue';
</script>

<template>
    <footer v-if="cookieBannerMounted" class="flex justify-end px-4 pb-4">
        <a
            :href="COOKIE_SETTINGS_HASH"
            :title="_mft('cookieBanner:cookieSettings')"
            class="mf-link-immune inline-flex p-2 bg-white shadow-md rounded-wl"
        >
            <span class="relative inline-block w-5 h-5" aria-hidden="true">
                <IconCookie class="w-5 h-5" />
                <span class="absolute -right-1 -bottom-1 rounded-full bg-white">
                    <IconSettings class="w-3 h-3" />
                </span>
            </span>
            <span class="sr-only">
                <mf-translate domainkey="cookieBanner:cookieSettings"></mf-translate>
            </span>
        </a>
    </footer>
</template>
